import {creates, elementFactory, hoistCmp, HoistProps, MenuItemLike} from '@xh/hoist/core';
import {CytoGraphModel} from './CytoGraphModel';
import {CtxMenuArgs, EdgeCreatedArgs, IGraphElement, NodeMoveArgs} from './CytoGraphTypes';
import {LayoutOptions} from 'cytoscape';
import {CytoscapeNodeHtmlParams} from './NodeHtml';
import {panel} from '@xh/hoist/desktop/cmp/panel';
import CytoscapeComponent from 'react-cytoscapejs';
import {getStyleObj} from './CytoGraphDefaults';
import './CytoGraph.scss';

export interface CytoGraphProps extends HoistProps<CytoGraphModel> {
    graphModelFn?: (model: CytoGraphModel) => void;
    showBackground?: boolean;
    elements: IGraphElement[];
    layout: LayoutOptions;
    nodeHtmlStyles?: CytoscapeNodeHtmlParams[];
    onNodeClickFn?: (id: string) => void;
    onNodeDblClickFn?: (id: string) => void;
    onNodeMoveFn?: (args: NodeMoveArgs) => void;
    onEdgeDrawnFn?: (args: EdgeCreatedArgs) => boolean;
    onLayoutChangedFn?: () => void;
    graphContextMenuItemsFn?: (args: CtxMenuArgs) => MenuItemLike[];
    nodeContextMenuItemsFn?: (args: CtxMenuArgs) => MenuItemLike[];
    edgeContextMenuItemsFn?: (args: CtxMenuArgs) => MenuItemLike[];
}

const cytoscapeComponent = elementFactory(CytoscapeComponent);

export const cytoGraph = hoistCmp.factory<CytoGraphProps>({
    model: creates(CytoGraphModel),
    render({model, ...props}) {
        return panel({
            ref: model.graphPanelRef,
            className: props.showBackground ? 'cy__bg-dotted' : 'cy__bg',
            item: cytoscapeComponent({
                cy: cy => {
                    model.cyObj = cy;
                    props.graphModelFn?.(model);
                },
                elements: props.elements,
                style: {width: '100%', height: '100%'},
                stylesheet: getStyleObj(),
                zoom: 1
            })
        });
    }
});
